<template>
    <div :class="[iconClass.name, 'ft24', ylIconClass.color, { 'hide': !iconClass.isShow.status }]"></div>
</template>
<script>
export default {
    name: 'yl-lc-icon',
    props:{
        iconClass: {
            type: Object,
            required:true,
            defalut: {   
            }
        }
    },
    computed: {
        ylIconClass(){
            if(this.iconClass.type){
                return this.iconList.find(item => item.type === this.iconClass.type)
            }
            return { color: 'successTextColor'}
        },
    },
    data(){
        return{
            iconList: [
                { type: 'success', color: "successTextColor"},
                { type: 'error',color: "dangerTextColor"},
                { type: 'warning',color: "warningTextColor"},
                ]
        }
    },
    methods: {
    },
}
</script>